import { render, staticRenderFns } from "./OrganizationDocumentsPage.vue?vue&type=template&id=35b70772"
import script from "./OrganizationDocumentsPage.vue?vue&type=script&lang=js"
export * from "./OrganizationDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports